// extracted by mini-css-extract-plugin
export default {"tableDiv":"primetable_tableDiv__tjGcp","noData":"primetable_noData__joy7d","loader":"primetable_loader__2iriE"};